// extracted by mini-css-extract-plugin
module.exports = {"core-layout":"CoreLayout_core-layout__3UXNv","loading":"CoreLayout_loading__6bjm9","core-layout-content":"CoreLayout_core-layout-content__4gcYS"};